const columns = (userList) => ([
  {
    title: 'Title',
    dataIndex: 'title',
    key: 'title',
  },
  {
    title: 'Message',
    dataIndex: 'message',
    key: 'message',
    customRender: ({ value }) => ((value || '').slice(0, 25)),
  },
  {
    title: 'User',
    dataIndex: '',
    key: 'user',
    filters: userList,
    onFilter: (value, record) => (
      (record.user || '').indexOf(value) === 0
    ),
    customRender: ({ value }) => {
      const { user } = value;
      const {
        firstName = '',
        lastName = '',
        email = '',
      } = user || {};
      const userName = email
        ? `${firstName} ${lastName} (${email})`
        : `${firstName || ''} ${lastName || ''}`;
      return userName;
    },
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
